import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import Modal from 'legacy/components/Modal/Modal'

const DialogWrapper = styled(Modal)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  overflow: auto;

  color: ${getToken('color-neutral-darker')};
  font-size: 14px;

  p {
    margin-bottom: 20px;

    line-height: 20px;
  }
`

export default DialogWrapper
